import common from './components/common';
import initSwiper from './components/swiper-custom';

// eslint-disable-next-line no-undef
__webpack_public_path__ = '/themes/custom/illuma/dist/';

/**
 * @file
 */
/* eslint-disable global-require */
(function($) {
  $(document).ready(function() {
    common.initialize();
    initSwiper();

    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      $('html').addClass('no-touchevents');
    }
    common.accordionToggle('.main-nav-toggle', '.region-sub-header>nav');
    common.backTop();
  });

  if ($('.buy-and-store').length) {
    import(/* webpackChunkName: "buyNow" */ './components/buyNow').then(({ default: BuyNow }) => {
      new BuyNow().init();
    });
  }

  if ($('.js-useful-links').length) {
    import(/* webpackChunkName: "usefulLinks" */ './components/usefulLinks').then(({ default: initUsefulLinks }) => {
      initUsefulLinks();
    });
  }
  $('.leave').on('click', () => {
    let currentLength = history.length;
    if(currentLength == 1) {
      $('.fedd-close').click()
    }else{
      history.go(-1)
    }
  });
})(jQuery);